import { render, staticRenderFns } from "./InventPrice.vue?vue&type=template&id=1383c8be"
import script from "./InventPrice.vue?vue&type=script&lang=js"
export * from "./InventPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports